import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Menu,
    MenuItem,
    OutlinedInput,
    Paper,
    Skeleton,
    Typography,
    useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { styles } from "../../style";
import { Person } from "../../icons/Person";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { Search as SearchIcon } from "@mui/icons-material";

import { useAuth } from "../../hooks/useAuth";
import { query } from "../../services/salesforce";
import { FeeRequestCard } from "./feeRequestCard";
import { skeleton } from "./skeleton";
import NoDataPresentUI from "../../components/NoDataPresentUI";

let timer = "";
function MyFeeRequests() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const filterOpen = Boolean(anchorEl);
    const [statusFilter, setStatusFilter] = useState("All");
    const [feeRequests, setFeeRequests] = useState([]);
    const [searchText, setSearchText] = useState("");

    const [loading, setLoading] = useState(true);

    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    useEffect(() => {
        query("feeRequest", "getFeeRequests", { contactId: userDetails.contact.id }).then((result) => {
            if (result.isSuccess) {
                if (result.data?.length > 0) {
                    result.data = result.data.map((item) => {
                        return {
                            ...item,
                            searchData: Object.keys(item)
                                .map((key) => item[key])
                                .join(" ")
                                .toLowerCase(),
                        };
                    });
                }
                setFeeRequests(result.data);
            }
            setLoading(false);
        });
    }, []);

    const theme = useTheme();

    const handleFilterMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleFilterMenuClose = (filterValue) => {
        setStatusFilter(filterValue);
        setAnchorEl(null);
    };

    const handleSearchChange = (event) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            const searchValue = event.target.value?.toLowerCase();
            setSearchText(searchValue);
        }, 500);
    };

    const getFeeRequests = () => {
        if (feeRequests?.length === 0) {
            return [];
        }
        return feeRequests?.filter((item) => {
            if (statusFilter !== "All" && item.status !== statusFilter) {
                return false;
            }
            if (searchText && !item.searchData.includes(searchText)) {
                return false;
            }
            return true;
        });
    };

    if (loading) {
        return skeleton;
    }

    return (
        <div>
            <Paper sx={{ ...styles.card, mb: "1rem", padding: "20px 24px" }}>
                <Typography component={"h1"} variant="h5">
                    My Speaker Requests
                </Typography>
                <Typography component={"p"} variant="body1">
                    Track and manage your speaker fee requests
                </Typography>
            </Paper>

            <Box
                display={"flex"}
                alignItems={{
                    xs: "flex-start",
                    sm: "center",
                }}
                justifyContent={"space-between"}
                flexDirection={{
                    xs: "column",
                    sm: "row",
                }}
                sx={{
                    [theme.breakpoints.down("sm")]: {
                        "&>*": {
                            width: "100%",
                            marginTop: "1rem",

                            "&:first-of-type": {
                                marginTop: 0,
                            },
                        },
                    },
                }}>
                <Box>
                    Filter by:
                    <Button
                        id="filter-fee-requests"
                        aria-controls={filterOpen ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={filterOpen ? "true" : undefined}
                        onClick={handleFilterMenuClick}
                        startIcon={<Person sx={{ color: "#4F46E5", width: "18px", height: "18px" }} />}
                        endIcon={<KeyboardArrowDownOutlinedIcon color="brand" />}
                        sx={{ ...styles.outlinedButton, marginLeft: "0.5rem" }}
                        variant="outlined">
                        {`Status: ${statusFilter}`}
                    </Button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={filterOpen}
                        onClose={() => handleFilterMenuClose("All")}
                        MenuListProps={{
                            "aria-labelledby": "filter-speakers",
                        }}>
                        <MenuItem onClick={() => handleFilterMenuClose("All")} value="All">
                            All
                        </MenuItem>
                        <MenuItem onClick={() => handleFilterMenuClose("New")} value="New">
                            New
                        </MenuItem>
                        <MenuItem onClick={() => handleFilterMenuClose("Approved")} value="Approved">
                            Approved
                        </MenuItem>
                        <MenuItem onClick={() => handleFilterMenuClose("In Progress")} value="In Progress">
                            In Progress
                        </MenuItem>
                        <MenuItem onClick={() => handleFilterMenuClose("Declined")} value="Declined">
                            Declined
                        </MenuItem>
                    </Menu>
                </Box>

                <Box>
                    <OutlinedInput
                        placeholder="Search"
                        size="small"
                        onChange={handleSearchChange}
                        componentsProps={{
                            input: {
                                sx: {
                                    padding: "0.5rem 1rem",
                                },
                            },
                            root: {
                                sx: {
                                    borderRadius: "8px",
                                    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                                    background: "#fff",

                                    width: {
                                        xs: "100%",
                                        sm: "unset",
                                    },
                                },
                            },
                        }}
                        startAdornment={<SearchIcon color="brand" />}
                    />
                </Box>
            </Box>

            <Box>
                {getFeeRequests()?.length === 0 && (
                    <Box sx={{ display: "flex", justifyContent: "center", marginTop: "7rem" }}>
                        <NoDataPresentUI
                            containerSx={{
                                width: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "60%",
                                },
                            }}
                            heading="You have not submitted any fee requests."
                        />
                    </Box>
                )}
                {getFeeRequests()?.map((cItem, index) => (
                    <FeeRequestCard userDetails={userDetails} key={cItem.id} cItem={cItem} />
                ))}
            </Box>
        </div>
    );
}

export default MyFeeRequests;
